import FieldProgress from "../../../generic/progress/progress"
import FieldConfig from "../../../proto/field-config"
import Project from "../../../../model2/project/project"
import FieldProgress_TableCell from "../../../generic/progress/render/table/table-cell"

// Progress based on numebr of tasks - used in posrtolfio summary and table views
export default class FieldProjectProgressTasks extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Progress tasks"
        this.label                                  = _.get(config, 'label', 'Progress tasks')
        this.icon                                   = 'i5-progress'

        // this.hasCalculatedValues                    = true

        // this.renderComponents.tableCell             = FieldProgress_TableCell
        this.renderComponents.tableCellCalculated   = FieldProgress_TableCell

        // this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange
    }

    canEdit(model:Project):boolean {
        return false
    }
}